var render = function (_h,_vm) {var _c=_vm._c;return _c('footer',{staticClass:"the-footer flex-wrap justify-between merchant-foot",class:_vm.classes})}
var staticRenderFns = []

export { render, staticRenderFns }